/**
 * Onboarding localStorage persistence
 */

const ONBOARDING_VERSION = "v1";

const KEYS = {
  completed: `${ONBOARDING_VERSION}-onboarding-completed`,
  type: `${ONBOARDING_VERSION}-onboarding-type`,
} as const;

export type OnboardingType = "new" | "professional" | null;

/**
 * Check if onboarding has been completed
 */
export const getOnboardingCompleted = (): boolean => {
  if (typeof window === "undefined") return false;
  try {
    const value = window.localStorage.getItem(KEYS.completed);
    return value === "true";
  } catch {
    return false;
  }
};

/**
 * Set onboarding completion status
 */
export const setOnboardingCompleted = (completed: boolean): void => {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(KEYS.completed, String(completed));
  } catch {
    // Ignore localStorage errors
  }
};

/**
 * Get the onboarding type the user selected
 */
export const getOnboardingType = (): OnboardingType => {
  if (typeof window === "undefined") return null;
  try {
    const value = window.localStorage.getItem(KEYS.type);
    if (value === "new" || value === "professional") {
      return value;
    }
    return null;
  } catch {
    return null;
  }
};

/**
 * Set the onboarding type
 */
export const setOnboardingType = (type: OnboardingType): void => {
  if (typeof window === "undefined") return;
  try {
    if (type === null) {
      window.localStorage.removeItem(KEYS.type);
    } else {
      window.localStorage.setItem(KEYS.type, type);
    }
  } catch {
    // Ignore localStorage errors
  }
};

/**
 * Reset onboarding state (for restarting the tour)
 */
export const resetOnboarding = (): void => {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.removeItem(KEYS.completed);
    window.localStorage.removeItem(KEYS.type);
  } catch {
    // Ignore localStorage errors
  }
};

